import { createContext } from 'react';

/**
 * @public
 */
var MotionConfigContext = /*#__PURE__*/createContext({
  transformPagePoint: function transformPagePoint(p) {
    return p;
  },
  isStatic: false
});
export { MotionConfigContext };